import styles from './style.module.css';
import { Link } from 'react-router-dom';


const About = () => {
    return (
        <div className={styles.about_section}>
            <div className={styles.title}>О нас</div>
            <div className={styles.content}>
                <p>
                    Межрегиональная общественная организация «Московское общество фтизиатров» (МОО «МОФ») - это основанное на членстве, добровольное общественное объединение граждан,
                    которое создано и действует в соответствии с Конституцией Российской Федерации, Федеральными законами «Об общественных объединениях», «О некоммерческих организациях»,
                    Гражданским кодексом Российской Федерации, другими законодательными актами Российской Федерации, а также общепризнанными принципами и нормами международного права и
                    Уставом (ознакомиться с которым можно на сайте общества по адресу www.m-o-f.ru).
                </p>
                <p>
                    Постоянно действующий руководящий орган Московского общества фтизиатров - Правление, располагающееся по адресу: 107014, г. Москва, ул. Стромынка, дом 10, строение 1.
                </p>
                <p>
                    Основной целью общества является профессиональная консолидация фтизиатров из разных регионов Российской Федерации для совершенствования организационной, теоретической и практической противотуберкулезной работы.
                </p>
                <p>
                    Побудительным мотивом к созданию Московского общества фтизиатров явилась необходимость объединения профессионалов для формирования единой позиции путем открытого обсуждения всех спорных проблем, адаптации достижений отдельных субъектов Российской Федерации к различным социально-экономическим и географическим условиям нашей Родины. Общество будет стремиться обеспечить:
                </p>
                <ul>
                    <li>развитие междисциплинарных связей;</li>
                    <li>взаимопомощь и информационную поддержку врачей различных специальностей, научных сотрудников, среднего медицинского персонала, оказывающих противотуберкулезную помощь населению Российской Федерации;</li>
                    <li>условия для наиболее эффективной реализации творческого потенциала членов общества в интересах развития теории и практики медицины;</li>
                    <li>пропаганду достижений медицинской науки в области фтизиатрии, содействие скорейшему распространению новейшей научной информации.</li>
                </ul>
                <p>
                    К вступлению в общество приглашаются достигшие 18 лет граждане Российской Федерации, иностранные граждане и лица без гражданства (законно находящиеся на территории Российской Федерации), а также общественные объединения и организации, которые заинтересованы в совместной работе по достижению поставленных целей, готовые признавать Устав общества, уплатить вступительный взнос и регулярно уплачивать членские взносы и принимать личное участие в работе общества.
                </p>
                <Link to="/about/"><button>Читать полностью...</button></Link>
            </div>
        </div>
    );
}

export default About;
